class p {
  constructor() {
    this.dpr = 1, this.eventsBound = !1, this.undoStack = [], this.redoStack = [], this.drawing = !1, this.lastX = 0, this.lastY = 0, this.fitMode = "contain", this.bgFill = "#ffffff", this.tool = "pen", this.eraserSize = 20, this.cssW = 0, this.cssH = 0;
  }
  get drawCtx() {
    const t = this, s = t.fgCtx ?? t.ctx;
    if (!s) throw new Error("Init() がまだ完了していません（描画コンテキスト未初期化）");
    return s;
  }
  /** === Init() 相当 === */
  Init(t) {
    var h;
    const s = typeof t.canvas == "string" ? document.querySelector(t.canvas) : t.canvas;
    if (!s) throw new Error("canvas not found");
    const e = s.parentElement;
    (h = e.style).position || (h.position = "relative"), this.bgCanvas = s, Object.assign(this.bgCanvas.style, {
      position: "absolute",
      left: "0",
      top: "0",
      right: "0",
      bottom: "0",
      zIndex: "0",
      // ← 背景は z-index:0
      background: "#ffffff"
      // ← 余白は白（従来の意図どおり）
    }), this.fgCanvas = document.createElement("canvas"), Object.assign(this.fgCanvas.style, {
      position: "absolute",
      left: "0",
      top: "0",
      right: "0",
      bottom: "0",
      zIndex: "1",
      // ← 前景を最前面へ
      // iPadのスクロール/ピンチを抑止（必須）
      touchAction: "none",
      background: "transparent"
    }), e.appendChild(this.fgCanvas), this.dpr = t.devicePixelRatioAware === !1 ? 1 : window.devicePixelRatio || 1;
    const a = t.width ?? (this.bgCanvas.clientWidth || 800), r = t.height ?? (this.bgCanvas.clientHeight || 600);
    this.bgCanvas.style.width = this.fgCanvas.style.width = a + "px", this.bgCanvas.style.height = this.fgCanvas.style.height = r + "px";
    const n = Math.round(a * this.dpr), i = Math.round(r * this.dpr);
    if (this.bgCanvas.width = this.fgCanvas.width = n, this.bgCanvas.height = this.fgCanvas.height = i, this.bgCtx = this.bgCanvas.getContext("2d", { willReadFrequently: !0 }), this.fgCtx = this.fgCanvas.getContext("2d", { willReadFrequently: !0 }), !this.bgCtx || !this.fgCtx) throw new Error("2D context unavailable");
    this.bgCtx.setTransform(1, 0, 0, 1, 0, 0), this.bgCtx.scale(this.dpr, this.dpr), this.fgCtx.setTransform(1, 0, 0, 1, 0, 0), this.fgCtx.scale(this.dpr, this.dpr), this.cssW = a, this.cssH = r, this.bgFill = "#fff", this.bgCtx.save(), this.bgCtx.fillStyle = this.bgFill, this.bgCtx.fillRect(0, 0, this.cssW, this.cssH), this.bgCtx.restore(), this.fgCtx.strokeStyle = "#000000", this.fgCtx.lineWidth = t.lineWidth ?? 3, this.fgCtx.lineCap = t.lineCap ?? "round", this.fgCtx.lineJoin = "round", this.fitMode = t.fit ?? "contain", this.tool = t.tool ?? "pen", this.eraserSize = t.eraserSize ?? 20, this.bindInputEvents(), this.snapshot();
  }
  SetTool(t) {
    this.tool = t;
  }
  SetEraser(t) {
    t.size && (this.eraserSize = t.size);
  }
  SetFit(t) {
    this.fitMode = t, this.redrawBackground();
  }
  /** === Load() 相当 === */
  async Load(t) {
    const s = "url" in t ? t.url : "blob" in t ? URL.createObjectURL(t.blob) : await this.resolve(t), e = await new Promise((a, r) => {
      const n = new Image();
      n.crossOrigin = "anonymous", n.onload = () => a(n), n.onerror = r, n.src = s;
    });
    this.bgImage = e, (!this.cssW || !this.cssH) && (this.cssW = this.bgCanvas.clientWidth || Math.round(this.bgCanvas.width / this.dpr), this.cssH = this.bgCanvas.clientHeight || Math.round(this.bgCanvas.height / this.dpr)), this.redrawBackground(), this.snapshot();
  }
  /**
   * 画像を合成してエクスポートする。
   * 互換: Save('blob'|'dataURL' = 'blob', quality=0.92)
   * 新式: Save({ return, format, quality, fileName, background, callback })
   */
  async Save(t = "blob", s = 0.92) {
    var d, v;
    const e = typeof t == "string", a = {
      return: e ? t : t.return ?? "blob",
      format: e ? "png" : t.format ?? "png",
      quality: e ? s : t.quality ?? 0.92,
      callback: typeof t == "object" ? t.callback : void 0
    }, r = a.format, n = r === "png" ? "image/png" : r === "jpeg" ? "image/jpeg" : "image/webp", i = ((d = this.bgCanvas) == null ? void 0 : d.width) ?? this.canvas.width, h = ((v = this.bgCanvas) == null ? void 0 : v.height) ?? this.canvas.height, o = document.createElement("canvas");
    o.width = i, o.height = h;
    const g = o.getContext("2d"), f = this.bgCanvas ?? this.canvas, C = this.fgCanvas;
    g.drawImage(f, 0, 0), C && g.drawImage(C, 0, 0);
    let c;
    if (a.return === "dataURL") {
      const l = o.toDataURL(n, a.quality);
      c = { kind: "dataURL", format: r, dataURL: l, size: l.length };
    } else {
      const l = await new Promise(
        (b) => o.toBlob((u) => b(u), n, a.quality)
      );
      c = { kind: "blob", format: r, blob: l, size: l.size };
    }
    try {
      a.callback && await a.callback(c);
    } catch (l) {
      console.error("onSave (per-call) failed:", l);
    }
    try {
      this.onSave && await this.onSave(c);
    } catch (l) {
      console.error("OnSave (global) failed:", l);
    }
    return c.kind === "dataURL" ? c.dataURL : c.blob;
  }
  Undo() {
    if (this.undoStack.length <= 1) return;
    const t = this.undoStack.pop();
    this.redoStack.push(t);
    const s = this.undoStack[this.undoStack.length - 1];
    this.fgCtx.putImageData(s, 0, 0);
  }
  Redo() {
    if (!this.redoStack.length) return;
    const t = this.redoStack.pop();
    this.undoStack.push(t), this.fgCtx.putImageData(t, 0, 0);
  }
  /** === Clear() 相当（注釈の消去。背景画像は保持） */
  Clear() {
    const t = this.fgCanvas.width / this.dpr, s = this.fgCanvas.height / this.dpr;
    this.fgCtx.clearRect(0, 0, t, s), this.snapshot();
  }
  /** 線の色・太さを動的変更 */
  SetStroke(t) {
    const s = this.drawCtx;
    t.strokeStyle !== void 0 && (s.strokeStyle = t.strokeStyle), t.lineWidth !== void 0 && (s.lineWidth = t.lineWidth), t.lineCap !== void 0 && (s.lineCap = t.lineCap);
  }
  /** 保存後のグローバル・フックを登録（上書き可・解除は undefined を渡す） */
  OnSave(t) {
    this.onSave = t;
  }
  /** ===== 内部実装 ===== */
  bindInputEvents() {
    if (this.eventsBound) return;
    this.eventsBound = !0;
    const t = this.fgCanvas;
    let s = null;
    const e = (i) => {
      const h = t.getBoundingClientRect(), o = i.clientX - h.left, g = i.clientY - h.top;
      return this.toLocal(o, g);
    }, a = (i) => {
      var g;
      if (i.pointerType === "mouse" && i.buttons !== 1) return;
      i.preventDefault(), s = i.pointerId, (g = t.setPointerCapture) == null || g.call(t, i.pointerId), this.drawing = !0;
      const { x: h, y: o } = e(i);
      this.lastX = h, this.lastY = o, this.fgCtx.save(), this.tool === "eraser" ? (this.fgCtx.globalCompositeOperation = "destination-out", this.fgCtx.lineWidth = this.eraserSize, this.fgCtx.lineCap = "round", this.fgCtx.lineJoin = "round") : this.fgCtx.globalCompositeOperation = "source-over", this.fgCtx.beginPath(), this.fgCtx.moveTo(h, o);
    }, r = (i) => {
      if (!this.drawing || s !== null && i.pointerId !== s) return;
      i.preventDefault();
      const { x: h, y: o } = e(i);
      this.fgCtx.lineTo(h, o), this.fgCtx.stroke(), this.lastX = h, this.lastY = o;
    }, n = (i) => {
      this.drawing && (this.drawing = !1, s = null, this.fgCtx.restore(), this.snapshot());
    };
    t.addEventListener("pointerdown", a, { passive: !1 }), t.addEventListener("pointermove", r, { passive: !1 }), window.addEventListener("pointerup", n, { passive: !1 }), window.addEventListener("pointercancel", n, { passive: !1 }), window.addEventListener("pointerleave", n, { passive: !1 }), t.addEventListener("contextmenu", (i) => i.preventDefault());
  }
  toLocal(t, s) {
    return { x: t, y: s };
  }
  snapshot() {
    this.redoStack.length = 0;
    try {
      const t = this.fgCtx.getImageData(0, 0, this.fgCanvas.width, this.fgCanvas.height);
      this.undoStack.push(t);
    } catch {
    }
  }
  async resolve(t) {
    const s = await t.resolver(t.objectId);
    return typeof s == "string" ? s : URL.createObjectURL(s);
  }
  async drawImageOnCanvas(t) {
    const s = await new Promise((C, c) => {
      const d = new Image();
      d.crossOrigin = "anonymous", d.onload = () => C(d), d.onerror = c, d.src = t;
    }), e = this.bgCanvas.width / this.dpr, a = this.bgCanvas.height / this.dpr;
    this.bgCtx.save(), this.bgCtx.fillStyle = this.bgFill, this.bgCtx.fillRect(0, 0, e, a);
    const r = Math.min(e / s.width, a / s.height), n = Math.max(e / s.width, a / s.height), i = this.fitMode === "cover" ? n : this.fitMode === "stretch" ? NaN : r;
    let h, o, g, f;
    this.fitMode === "stretch" ? (h = e, o = a, g = 0, f = 0) : (h = s.width * i, o = s.height * i, g = (e - h) / 2, f = (a - o) / 2), this.bgCtx.imageSmoothingEnabled = !0, this.bgCtx.imageSmoothingQuality = "high", this.bgCtx.drawImage(s, g, f, h, o), this.bgCtx.restore();
  }
  redrawBackground() {
    const t = this.cssW || Math.round(this.bgCanvas.width / this.dpr), s = this.cssH || Math.round(this.bgCanvas.height / this.dpr);
    if (this.bgCtx.save(), this.bgCtx.clearRect(0, 0, t, s), this.bgFill !== null && (this.bgCtx.fillStyle = this.bgFill ?? "#fff", this.bgCtx.fillRect(0, 0, t, s)), !this.bgImage) {
      this.bgCtx.restore();
      return;
    }
    const e = this.bgImage;
    let a, r, n, i;
    if (this.fitMode === "stretch")
      a = t, r = s, n = 0, i = 0;
    else {
      const h = Math.min(t / e.width, s / e.height), o = Math.max(t / e.width, s / e.height), g = this.fitMode === "cover" ? o : h;
      a = e.width * g, r = e.height * g, n = (t - a) / 2, i = (s - r) / 2;
    }
    this.bgCtx.imageSmoothingEnabled = !0, this.bgCtx.imageSmoothingQuality = "high", this.bgCtx.drawImage(e, n, i, a, r), this.bgCtx.restore();
  }
}
export {
  p as default
};
//# sourceMappingURL=canvas-annotator.es.js.map
